export default "__VITE_ASSET__Bavkm2pi__"